import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { FaPlaneDeparture } from 'react-icons/fa';
import { formatBookingDate } from 'helpers/utils';
import { Card, Badge } from 'components/common';

const BADGE_VARIANT = { 1: 'warning', 2: 'success', 3: 'danger', 4: 'danger', 5: 'info' };

const Field = ({ label, children, labelWidth = 'sm:tw-w-40' }) => (
  <div className="tw-flex tw-flex-col sm:tw-flex-row tw-gap-0.5 sm:tw-gap-2 tw-mb-1.5 tw-text-sm">
    <span className={`${labelWidth} sm:tw-flex-shrink-0 tw-font-semibold tw-text-slate-600`}>{label}</span>
    <span className="tw-text-blue-700 tw-min-w-0 tw-break-words">{children}</span>
  </div>
);
Field.propTypes = { label: PropTypes.node.isRequired, children: PropTypes.node, labelWidth: PropTypes.string };

const SectionTitle = ({ children }) => (
  <h6 className="tw-text-xs tw-font-bold tw-uppercase tw-tracking-widest tw-text-slate-500 tw-mb-3">{children}</h6>
);
SectionTitle.propTypes = { children: PropTypes.node };

const TransactionDetailBookingInfo = ({ transaction }) => {
  const statusId = transaction.status_id;

  return (
    <Card padding="none" className="tw-mb-3" header={<h5 className="tw-mb-0 tw-font-semibold tw-text-slate-800">Booking information</h5>}>
      <div className="tw-bg-slate-50 tw-p-4">
        <div className="tw-grid tw-grid-cols-1 lg:tw-grid-cols-2 tw-gap-6">
          {/* Information */}
          <div>
            <SectionTitle>Information</SectionTitle>
            <Field label="Booking number"><span className="tw-font-bold">{transaction.booking_number}</span></Field>
            <Field label="From date">{formatBookingDate(transaction.from_date)}</Field>
            <Field label="To date">{formatBookingDate(transaction.to_date)}</Field>
            <Field label="Address pickup location">{transaction.pickup_location}</Field>
            <Field label="Address drop location">{transaction.drop_location}</Field>
            <Field label="Purpose trip"><span style={{ whiteSpace: 'pre-line' }}>{transaction.description}</span></Field>
            <Field label="Status"><Badge variant={BADGE_VARIANT[statusId] || 'info'} size="sm">{transaction.status_name}</Badge></Field>
            <Field label="Route">{transaction.route}</Field>
          </div>

          {/* Contact */}
          <div>
            <SectionTitle>Contact</SectionTitle>
            <Field label="Name of passengers">
              <span className="tw-flex tw-flex-wrap tw-gap-1">
                {(transaction.name_of_passengers || []).map((item, i) => (
                  <Badge key={i} variant="primary" size="sm">{item}</Badge>
                ))}
              </span>
            </Field>
            <Field label="Number of passengers">{transaction.number_of_passengers}</Field>
            <Field label="Luggage">{transaction.luggage === null ? 'None' : transaction.luggage}</Field>
            <Field label="Phone contacts">{transaction.phone_contacts}</Field>
            <Field label="Site">{transaction.site_name}</Field>

            {transaction?.travel_booking_id && (
              <Field label={<><FaPlaneDeparture className="tw-inline tw-mr-1" /> Source from Travel booking</>}>
                <Link to={`/booking/travel/${transaction.travel_booking_id}`} target="_blank">{transaction.travel_booking_number}</Link>
              </Field>
            )}
          </div>
        </div>

        <div className="tw-grid tw-grid-cols-1 lg:tw-grid-cols-2 tw-gap-6 tw-mt-6">
          <div />
          <div>
            <SectionTitle>Created</SectionTitle>
            <Field label="Submited by">{transaction.created_by}</Field>
            <Field label="Submited date">{transaction.created_at}</Field>
            <Field label="Updated date">{transaction.updated_at}</Field>
          </div>
        </div>
      </div>
    </Card>
  );
};

TransactionDetailBookingInfo.propTypes = {
  transaction: PropTypes.object.isRequired,
};

export default TransactionDetailBookingInfo;
